<script setup>
import { ref } from 'vue';
import FordLogo from '@/components/FordLogo.vue';
import { useStore } from 'vuex';
import FooterMobile from './FooterMobile.vue';
import FooterDesktop from './FooterDesktop.vue';

const footerLinks = ref([
  {
    text: 'FordPro.com',
    url: 'https://www.fordpro.com/',
  },
  {
    text: 'Terms & Conditions',
    url: 'https://fordpro.com/en-us/terms/',
  },
  {
    text: 'Do Not Sell My Personal Information',
    url: 'https://www.ford.com/help/privacy/ccpa/?ccpatype=donotsellmypi',
  },
  {
    text: 'Privacy',
    url: 'https://fordpro.com/en-us/privacy/',
  },
  {
    text: 'Cookie Settings',
    url: '#',
  },
]);

defineProps({ eventTypes: Array });

const currentYear = new Date().getFullYear();
const copyWrite = ref(currentYear);

const store = useStore();
const setEventType = (id) => {
  store.commit('home/setEventType', id);
};

const emit = defineEmits(['notify']);
</script>

<template>
  <footer
    class="
      z-[1]
      container-xxl
      bg-white bg-footer bg-contain bg-no-repeat bg-bottom
      tablet:bg-footer-desktop
      tablet:bg-auto
      tablet:[background-position:center_188%]
      font-FordAntennaMed
      text-ford-gray-dark text-sm
      min-h-[344px]
      pb-20
      tablet:min-h-[490px] tablet:pt-[60px]
    "
  >
    <footer-mobile
      :footerLinks="footerLinks"
      :eventTypes="eventTypes"
      class="mb-5"
      @set-event-type="setEventType"
      @notify="() => emit('notify')"
    />
    <footer-desktop
      :footerLinks="footerLinks"
      :eventTypes="eventTypes"
      class="mb-10"
      @set-event-type="setEventType"
      @notify="() => emit('notify')"
    />
    <ford-logo class="w-[110px] tablet:w-[150px] mx-auto mb-2" />
    <a
      href="https://corporate.ford.com/home.html"
      target="_blank"
      class="
        flex
        justify-center
        text-ford-blue-dark text-[10px]
        hover:text-ford-blue-electric
        tablet:text-sm
      "
    >
      &copy; {{ copyWrite }} Ford Motor Company
    </a>
  </footer>
</template>
